import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw,
} from 'vue-router';
import appRoutes from './app';
import userRoutes from '../app/user/user-routes';
import useRoot from '../app/root/use-root';
import useUser from '../app/user/use-user';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () =>
      import('@/app/shared/components/layouts/wrapper-layout-component.vue'),
    beforeEnter: async (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      const rootStore = useRoot();
      const { isUserLoggedIn } = useUser();

      if (to.name === 'app.reset_password') {
        next();
      }

      const loggedIn = await isUserLoggedIn();

      if (loggedIn && to.name === 'app.login') {
        await rootStore.init();
        next({ name: 'app.home' });
      }

      if (loggedIn) {
        await rootStore.init();
        next();
      }

      if (to.name !== 'app.login' && !loggedIn) {
        next({ name: 'app.login' });
      }

      next();
    },
    children: [...appRoutes, ...userRoutes],
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

router.afterEach((to) => {
  gtag('set', 'page', to.path);
  gtag('send', 'pageview');
});

export default router;
